type BrowserStorageName = 'localStorage' | 'sessionStorage';

/** 存储在 WebView 中可能为 null，getter 或具体操作也可能抛错；缓存失败不阻断业务。 */
function createSafeBrowserStorage(name: BrowserStorageName) {
  return {
    getItem(key: string): string | null {
      try {
        return typeof window === 'undefined' ? null : (window[name]?.getItem(key) ?? null);
      } catch {
        return null;
      }
    },
    setItem(key: string, value: string): void {
      try {
        if (typeof window !== 'undefined') window[name]?.setItem(key, value);
      } catch {
        // 禁用存储或额度不足时保留当前页面的内存状态。
      }
    },
    removeItem(key: string): void {
      try {
        if (typeof window !== 'undefined') window[name]?.removeItem(key);
      } catch {
        // 清理缓存失败不应中断当前页面。
      }
    },
  };
}

export const safeLocalStorage = createSafeBrowserStorage('localStorage');
export const safeSessionStorage = createSafeBrowserStorage('sessionStorage');
